import { render, staticRenderFns } from "./platinfoca-add-or-update.vue?vue&type=template&id=1a72d41d&"
import script from "./platinfoca-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platinfoca-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports